export const UPLOADFILES_RESET_STATE = 'UPLOADFILES_RESET_STATE';
export const UPLOADFILES_CURRENT_ITEM = 'UPLOADFILES_CURRENT_ITEM';

export const UPLOADFILES_REQUEST_LOADING = 'UPLOADFILES_REQUEST_LOADING';
export const UPLOADFILES_REQUEST_SUCCESS = 'UPLOADFILES_REQUEST_SUCCESS';
export const UPLOADFILES_REQUEST_FAILED = 'UPLOADFILES_REQUEST_FAILED';

export const UPLOADFILES_CURRENT_ACTION = 'UPLOADFILES_CURRENT_ACTION';
export const UPLOADFILES_RESET_ACTION = 'UPLOADFILES_RESET_ACTION';